import { apiSlice } from '../api/apiSlice'
import { RequestProps, Technology, TechnologiesResponse } from '../../types'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    GetTechnologies: builder.query<TechnologiesResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: 'technologies',
        params: props,
      }),
      transformResponse: (responseData: TechnologiesResponse) => {
        return responseData
      },
      providesTags: result => (result ? [{ type: 'Technology', id: 'LIST' }] : [{ type: 'Technology', id: 'LIST' }]),
    }),

    getTechnologyById: builder.query<Technology, string>({
      query: (id: string) => `/technologies/${id}`,
      transformResponse: (responseData: Technology) => {
        return responseData
      },
      providesTags: () => [{ type: 'Technology', id: 'LIST' }],
    }),

    getTechnologyTypes: builder.query({
      query: () => `/technologies/types`,
      transformResponse: (responseData: string[]) => {
        return responseData
      },
      providesTags: () => [{ type: 'Technology', id: 'LIST' }],
    }),

    getTechnologyExtensions: builder.query({
      query: () => `/technologies/extensions`,
      transformResponse: (responseData: string[]) => {
        return responseData
      },
      providesTags: () => [{ type: 'Technology', id: 'LIST' }],
    }),

    createTechnology: builder.mutation({
      query: (technology: Partial<Technology>) => ({
        url: '/technologies',
        method: 'POST',
        body: technology,
      }),
      invalidatesTags: () => [{ type: 'Technology', id: 'LIST' }],
    }),

    editTechnology: builder.mutation<Technology, EditArgs>({
      query: ({ id, technology }) => ({
        url: `/technologies/${id}`,
        method: 'PUT',
        body: technology,
      }),
      invalidatesTags: () => [{ type: 'Technology', id: 'LIST' }],
    }),

    deleteTechnology: builder.mutation<Technology, number>({
      query: (id: number) => ({
        url: `/technologies/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: 'Technology', id: 'LIST' }],
    }),
  }),
})

type EditArgs = {
  id: number
  technology: Partial<Technology>
}

// Generated hooks
export const {
  useGetTechnologiesQuery,
  useGetTechnologyByIdQuery,
  useGetTechnologyTypesQuery,
  useGetTechnologyExtensionsQuery,
  useCreateTechnologyMutation,
  useEditTechnologyMutation,
  useDeleteTechnologyMutation,
} = extendedApiSlice
